import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as NegotiationActions from '../../../../actions/NegotiationActions';
import Loader from '../../../../components/Loader';
import './style.scss';

class Comprehensiveness extends Component {
  componentDidMount = () => {
    //this.props.fillComprehensiveness();
  };

  close = () => {
    this.props.hiddenSelectComprehensiveness(true);
  };

  handleSubmit = event => {
    event.preventDefault();
    this.props.hiddenSelectComprehensiveness();
  };

  handleChangeComprehensiveness(comprehensiveness) {
    const comprehensivenessSelecteds = this.props.negotiaton.comprehensiveness;

    if (comprehensivenessSelecteds.find(c => c.id === comprehensiveness.id))
      this.props.uncheckedComprehensiveness(comprehensiveness);
    else this.props.checkedComprehensiveness(comprehensiveness);
  }

  chunkArrayInGroups = (arr, size) => {
    var result = [];
    for (var i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  handleChangeUfs = (uf) => {
    if ((this.props.negotiaton.comprehensiveness.find(c => c.estado === uf) || []).length === (this.props.comprehensivenessOptions.find(c => c.estado === uf) || []).length)
      this.props.unChangedRegion(uf);
    else
      this.props.changedRegion(uf);
  }

  handleChangeNacional = (nacional) => {
    if ((this.props.negotiaton.comprehensiveness.filter(c => c.filiada === nacional) || []).length === (this.props.comprehensivenessOptions.filter(c => c.filiada === nacional) || []).length)
      this.props.uncheckedNacional(nacional);
    else
      this.props.checkedNacional(nacional);
  }

  handleChangeRegion = (region) => {
    if ((this.props.negotiaton.comprehensiveness.filter(c => c.regiao === region) || []).length === (this.props.comprehensivenessOptions.filter(c => c.regiao === region) || []).length)
      this.props.unCheckedUfs(region);
    else
      this.props.checkedUfs(region);
  }

  render = () => {
    const comprehensivenessOptionsGroups = this.chunkArrayInGroups(
      this.props.comprehensivenessOptions || [],
      22
    );

    return (
      <>
      <div className="select-comprehensiveness">
        <Loader />
        <div className="row content-box">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 right-column">
            <div className="title-form">
              <div className="title-text">
                <p className="text txt-register">Selecione a</p>
                <p className="text txt-new">
                  Abrangência
                  <span className="count-selected">
                    ({this.props.negotiaton.comprehensiveness.length})
                  </span>
                </p>

              </div>
            </div>
            <div className="form-container">
              <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 group-box">
                    <span className="text group-box-text">Nacional</span>
                  </div>
                  <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8 group-box">
                    <span className="text group-box-text">Regional</span>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 group-options-box">
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group option">
                  <div className="pretty p-svg p-curve p-bigger">
                    <input
                      type="checkbox"
                      name="comprehensiveness"
                      checked={(this.props.negotiaton.comprehensiveness.filter(c => c.filiada === 'Propria') || []).length === (this.props.comprehensivenessOptions.filter(c => c.filiada === 'Propria') || []).length && (this.props.comprehensivenessOptions.filter(c => c.filiada === 'Propria') || []).length > 0}
                      onChange={e =>
                        this.handleChangeNacional('Propria')
                      }
                    />
                    <div className="state p-success">
                      <svg className="svg svg-icon" viewBox="0 0 20 20">
                        <path
                          className="check"
                          d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                        />
                      </svg>
                      <label className="text txt-option">Próprias</label>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group option">
                  <div className="pretty p-svg p-curve p-bigger">
                    <input
                      type="checkbox"
                      name="comprehensiveness"
                      checked={(this.props.negotiaton.comprehensiveness.filter(c => c.filiada === 'Afiliada') || []).length === (this.props.comprehensivenessOptions.filter(c => c.filiada === 'Afiliada') || []).length && (this.props.comprehensivenessOptions.filter(c => c.filiada === 'Afiliada') || []).length > 0}
                      onChange={e =>
                        this.handleChangeNacional('Afiliada')
                      }
                    />
                    <div className="state p-success">
                      <svg className="svg svg-icon" viewBox="0 0 20 20">
                        <path
                          className="check"
                          d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                        />
                      </svg>
                      <label className="text txt-option">Afiliadas</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 group-options-box">
                {this.props.regions.map(r => (
                <div className={`col-lg-${r === 'Centro-Oeste' ? '3' : '2'} col-md-2 col-sm-2 col-xs-2 form-group option`} key={r}>
                  <div className="pretty p-svg p-curve p-bigger">
                    <input
                      type="checkbox"
                      name="comprehensiveness"
                      checked={(this.props.negotiaton.comprehensiveness.filter(c => c.regiao === r) || []).length === (this.props.comprehensivenessOptions.filter(c => c.regiao === r) || []).length}
                      onChange={e =>
                        this.handleChangeRegion(r)
                      }
                    />
                    <div className="state p-success">
                      <svg className="svg svg-icon" viewBox="0 0 20 20">
                        <path
                          className="check"
                          d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                        />
                      </svg>
                      <label className="text txt-option">{r}</label>
                    </div>
                  </div>
                </div>
                ))}
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 group-box">
                  <span className="text group-box-text">Estadual</span>
                </div>
              </div>

              <div className="row">
              <div className="c ons-box">
                {this.props.ufs.map(u => (
                <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 form-group option" key={u}>
                  <div className="pretty p-svg p-curve p-bigger">
                    <input
                      type="checkbox"
                      name="comprehensiveness"
                      checked={(this.props.negotiaton.comprehensiveness.filter(c => c.estado === u) || []).length === (this.props.comprehensivenessOptions.filter(c => c.estado === u) || []).length}
                      onChange={() =>
                        this.handleChangeUfs(u)
                      }
                    />
                    <div className="state p-success">
                      <svg className="svg svg-icon" viewBox="0 0 20 20">
                        <path
                          className="check"
                          d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                        />
                      </svg>
                      <label className="text txt-option">{u}</label>
                    </div>
                  </div>
                </div>
                ))}
              </div>

              </div>
              <hr/>
              <div className="row">

                {comprehensivenessOptionsGroups.map(g => (
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6 options-box" key={g}>
                    {g.map(o => (
                      <div
                        className="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group option"
                        key={o.id}
                      >
                        <div className="pretty p-svg p-curve p-bigger">
                          <input
                            type="checkbox"
                            name="comprehensiveness"
                            checked={
                              this.props.negotiaton.comprehensiveness.find(
                                c => c.id === o.id
                              )
                                ? true
                                : false
                            }
                            onChange={e =>
                              this.handleChangeComprehensiveness(o)
                            }
                          />
                          <div className="state p-success">
                            <svg className="svg svg-icon" viewBox="0 0 20 20">
                              <path
                                className="check"
                                d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                              />
                            </svg>
                            <label className="text txt-option">{o.nome}</label>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}

              </div>

              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 action-box">
                  <button
                    type="button"
                    className="btn-normal btn-cancell"
                    onClick={this.close}
                  >
                    CANCELAR
                  </button>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 action-box">
                  <button type="submit" className="btn-normal btn-submit">
                    SALVAR ABRANGÊNCIA
                  </button>
                </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      </>
    );
  };
}

const mapStateToProps = ({ negotiationReducer }) => {
  return {
    ...negotiationReducer
  };
};

export default connect(
  mapStateToProps,
  { ...NegotiationActions }
)(Comprehensiveness);
